import UITileSection from 'UIComponents/tile/UITileSection';
import UITile from 'UIComponents/tile/UITile';
import UIAlert from 'UIComponents/alert/UIAlert';
import EnrollmentListSizeExactAlert from 'automation-ui-canvas/containers/review/EnrollmentListSizeExactAlert';
import useHasListsToolAccess from 'automation-ui-enrollment/hooks/useHasListsToolAccess';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ILSListPreviewLink from 'automation-ui-enrollment/components/common/ILSListPreviewLink';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import UIButton from 'UIComponents/button/UIButton';
import { getEnrollmentConfigRoute } from 'automation-ui-canvas/utils/absoluteRoutingUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHistory } from 'react-router-dom';
import ScheduledEnrollmentDetailsGroup from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentDetailsGroup';
import { isScheduledForPastDate } from 'automation-ui-enrollment/components/scheduledEnrollment/utils/isScheduledForPastDate';
import { getEnrollmentSchedule } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollExistingScheduleView = ({
  enrollmentList,
  flow
}) => {
  const history = useHistory();
  const hasListsToolAccess = useHasListsToolAccess(flow.objectTypeId);
  const previewLink = hasListsToolAccess && enrollmentList !== null && enrollmentList !== void 0 && enrollmentList.filterBranch ? /*#__PURE__*/_jsx(ILSListPreviewLink, {
    filterBranch: enrollmentList.filterBranch,
    workflowName: flow.name || '',
    objectTypeId: flow.objectTypeId,
    linkLabel: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.hybridCalculation.listsToolLink_cob",
      objectTypeId: flow.objectTypeId
    })
  }) : undefined;
  const enrollmentSchedule = getEnrollmentSchedule(flow);
  const shouldShowPastDateWarning = isScheduledForPastDate(enrollmentSchedule);
  const isObjectlessFlow = getIsObjectlessFlow(flow.toHybridFlowInterface());
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UITile, {
      compact: true,
      children: /*#__PURE__*/_jsx(UITileSection, {
        children: enrollmentList ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "m-bottom-3",
            children: enrollmentList && /*#__PURE__*/_jsx(EnrollmentListSizeExactAlert, {
              objectTypeId: flow.objectTypeId,
              listId: enrollmentList.listId,
              previewLink: previewLink
            })
          }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            objectTypeId: flow.objectTypeId,
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.schedule.description_cob"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [shouldShowPastDateWarning && /*#__PURE__*/_jsx(UIAlert, {
            className: "m-bottom-4",
            type: "warning",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "platformReview.v2.enrollmentStep.enrollExisting.schedule.pastDateWarning"
            })
          }), !isObjectlessFlow && /*#__PURE__*/_jsx(StyledCriteraBorder, {
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: flow.objectTypeId,
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.noSchedule_cob",
              isJsx: true
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "m-top-3",
            children: [/*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: flow.objectTypeId,
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.schedule.descriptionNoEnrollment_cob"
            }), /*#__PURE__*/_jsx(ScheduledEnrollmentDetailsGroup, {
              className: "m-top-2",
              enrollmentSchedule: enrollmentSchedule,
              objectTypeId: flow.objectTypeId
            })]
          }), !isObjectlessFlow && /*#__PURE__*/_jsx(UIButton, {
            className: "m-top-3",
            use: "tertiary",
            size: "small",
            onClick: () => {
              history.push({
                pathname: getEnrollmentConfigRoute({
                  flow
                }),
                search: history.location.search
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "platformReview.v2.enrollmentStep.enrollment.editFilterCriteria"
            })
          })]
        })
      })
    })
  });
};
export default EnrollExistingScheduleView;